export default {
  data() {
    return {
      minValueFt: 0,
      maxValueFt: 0
    };
  },
  methods: {
    checkFtCountForSubmit() {
      if (this.disabled) return true;
      const targetValue = this.modelValue.ftCount;
      if (!this.checkEmpty(targetValue)) return false;
      if (
        !this.isRealNumber(targetValue) ||
        Number(targetValue) < this.minValueFt ||
        Number(targetValue) > this.maxValueFt
      )
        return false;
      return true;
    },
    checkThresholdMinForSubmit() {
      const minValue = this.modelValue.thresholdMin;
      const existMax = this.modelValue.thresholdItem === 'range';

      if (!this.checkEmpty(minValue)) return false;
      if (!this.isRealNumber(minValue)) {
        return false;
      } else {
        if (!Number.isInteger(minValue * 1) && !this.isDotTwo(minValue)) {
          return false;
        }
      }
      if (existMax) {
        const maxValue = this.modelValue.thresholdMax;
        if (this.checkEmpty(maxValue) && !this.isThreshold(minValue, maxValue)) {
          return false;
        }
      }
      return true;
    },
    checkThresholdMaxForSubmit() {
      const minValue = this.modelValue.thresholdMin;
      const maxValue = this.modelValue.thresholdMax;
      if (!this.checkEmpty(maxValue)) return false;
      if (!this.isRealNumber(maxValue)) {
        return false;
      } else {
        if (!Number.isInteger(maxValue * 1) && !this.isDotTwo(maxValue)) {
          return false;
        }
      }
      if (this.checkEmpty(minValue) && !this.isThreshold(minValue, maxValue)) {
        return false;
      }
      return true;
    },
    chkPrefixLengthForSubmit() {
      this.modelValue.prefix = this.modelValue.prefix.trim();
      return !!this.modelValue.prefix && !this.validateTextInput(this.modelValue.prefix);
    },
    checkPrefixForSubmit() {
      let chkPrefix = this.modelValue.prefix.length;
      return !!this.modelValue.prefix && chkPrefix <= 20 && !this.validateTextInput(this.modelValue.prefix.trim());
    },
    checkEachItemForSubmit() {
      return !!this.modelValue.objectModel;
    },
    validateTextInput(text) {
      return this.$const.NOT_ALLOWED_REGEX.COMMON_INPUT.test(text);
    }
  }
};
